"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasVisibleComments = hasVisibleComments;
exports.commentClearError = commentClearError;
exports.batchCommentUpdate = exports.remapCommentNodes = exports.updateAnnotation = exports.commentsEdit = exports.commentConfirmForDelete = exports.commentCancelForDelete = exports.commentDeletePropose = exports.commentsPost = exports.postReply = exports.commentsOpen = exports.commentsResolve = exports.toggleResolved = exports.commentsSetShowAnnotations = exports.commentsToggleReply = exports.commentsFilterUsers = exports.commentsFilterTime = exports.commentsFilterClear = exports.commentsAddDirtyComment = exports.commentsUpdate = exports.commentsGet = exports.commentsClear = exports.commentsSetRecentActivity = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.clonedeep"));

var _commentsSdk = require("@ccx-public/comments-sdk");

var _ccxIngest = require("@ccx-public/ccx-ingest");

var _ingestEvents = _interopRequireDefault(require("../lib/ingestEvents"));

var _LocalStorageManager = _interopRequireDefault(require("../lib/LocalStorageManager"));

var _utils = require("../lib/utils");

var _constants = require("../constants");

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var getIngestController = function getIngestController() {
  return _ccxIngest.ccxController.getInstance(_constants.INGEST_PROJECT_VALUE);
};
/**
 * Helper function to remove clean unwanted properties for Comments Service
 * @param {object} comment - comment to be cleaned
 * @param {object} remappedMap - map of comment IDs to node information
 * @returns {object} cleaned copy of the comment
 */


function cleanCommentDataForCommentsService(comment) {
  var remappedMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cleanedComment = (0, _lodash2.default)(comment);
  delete cleanedComment.pinNum;
  delete cleanedComment.hasShapeAnnotation;
  delete cleanedComment.hasHighlightAnnotation;
  delete cleanedComment.hasInsertAnnotation;
  delete cleanedComment.hasReplaceAnnotation;
  delete cleanedComment.hasStrikethroughAnnotation;
  delete cleanedComment.recentActivity;
  delete cleanedComment.repliesOpen;
  delete cleanedComment.parentCommentId;
  delete cleanedComment.draftReplyText;
  delete cleanedComment.dirtyEdit;
  delete cleanedComment.dirtyReply;
  delete cleanedComment.imageContextData;
  delete cleanedComment.unmapped;

  if (remappedMap[cleanedComment.id]) {
    cleanedComment.target.selector.node.id = remappedMap[cleanedComment.id].original;
  }

  return cleanedComment;
}
/**
 * Scrub the mention data for just the attributes desired by the Comments Service
 *
 * @param {Array} mentions All of the mentions to be cleaned
 * @param {string} commentTxt The comment text which comtains the mentioned users
 * @returns {Array} Mentions data array with only the attributes desired by the Comments Service
 */


function cleanMentionDataForCommentsService(mentions, commentTxt) {
  var cleanedMentions = [];

  if (mentions) {
    // Scrub the mentions for only data that the comments service wants,
    //  specifically: id, name, type, and email
    for (var mentionIdx = 0; mentionIdx < mentions.length; mentionIdx++) {
      // Validate that the comment text contains the mention being passed
      if (commentTxt.includes(mentions[mentionIdx].id)) {
        cleanedMentions.push({
          id: mentions[mentionIdx].id,
          name: mentions[mentionIdx].name,
          type: mentions[mentionIdx].type,
          email: mentions[mentionIdx].email
        });
      }
    }
  }

  return cleanedMentions;
}
/**
 * Determines if any comments are currently visible.
 * @param {Array} comments - all comments
 * @param  {Object} assetData - meta data for current asset
 * @param  {Object} options - object with global comments related options
 * @returns {Boolean} True if comments are visible
 */


function hasVisibleComments() {
  var comments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var assetData = arguments.length > 1 ? arguments[1] : undefined;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var globalComments = options.globalComments,
      isGlobalCommentsToggleActive = options.isGlobalCommentsToggleActive,
      globalCommentsUnmapped = options.globalCommentsUnmapped;
  var openComments = comments.filter(function (_ref) {
    var status = _ref.status;
    return status === 'open';
  }); // "active global comments" only requires 1 comment to show, regardless of unmapped

  if (globalComments && isGlobalCommentsToggleActive && globalCommentsUnmapped) {
    return openComments.length > 0;
  } // "active global comments" but make sure at least 1 is mappable


  if (globalComments && isGlobalCommentsToggleActive) {
    var validNodeIds = [];

    if (assetData.useNodeIndex) {
      validNodeIds = assetData.validNodes.map(function (node, idx) {
        return idx;
      });
    } else {
      validNodeIds = assetData.validNodes.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
    }

    return Boolean(openComments.find(function (comment) {
      var _comment$target, _comment$target$selec, _comment$target$selec2;

      return validNodeIds.includes(comment === null || comment === void 0 ? void 0 : (_comment$target = comment.target) === null || _comment$target === void 0 ? void 0 : (_comment$target$selec = _comment$target.selector) === null || _comment$target$selec === void 0 ? void 0 : (_comment$target$selec2 = _comment$target$selec.node) === null || _comment$target$selec2 === void 0 ? void 0 : _comment$target$selec2.id);
    }));
  } // global comments is off, make sure 1 comment exists for active node


  if (assetData.nodeId) {
    return Boolean(openComments.find(function (comment) {
      var _comment$target2, _comment$target2$sele, _comment$target2$sele2;

      return (comment === null || comment === void 0 ? void 0 : (_comment$target2 = comment.target) === null || _comment$target2 === void 0 ? void 0 : (_comment$target2$sele = _comment$target2.selector) === null || _comment$target2$sele === void 0 ? void 0 : (_comment$target2$sele2 = _comment$target2$sele.node) === null || _comment$target2$sele2 === void 0 ? void 0 : _comment$target2$sele2.id) === assetData.nodeId;
    }));
  } // nodeless mode, ensure there is 1 comment.


  return Boolean(openComments.length);
}
/**
 * Action to clear an error.
 * @param {string} id - id of the error
 * @returns {undefined}
 */


function commentClearError(id) {
  return {
    type: _constants.COMMENTS_CLEAR_ERROR,
    id: id
  };
}
/**
 * Action to set recentActivity on a comment
 * @param {boolean} parentId - id of comment to update
 * @param {boolean} replyId - id of reply to update
 * @param {string} recentActivity - value for recentActivity
 * @returns {undefined}
 */


var commentsSetRecentActivity = function commentsSetRecentActivity(parentId) {
  var replyId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var recentActivity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return function (dispatch) {
    setTimeout(function () {
      requestAnimationFrame(function () {
        dispatch({
          type: _constants.COMMENTS_SET_RECENT_ACTIVITY,
          parentId: parentId,
          replyId: replyId,
          recentActivity: recentActivity
        });
      });
    }, 3000);
  };
};
/**
 * Action to clear comments feed
 * @returns {Promise} promise to resolve/reject once HTTP is completed
 */


exports.commentsSetRecentActivity = commentsSetRecentActivity;

var commentsClear = function commentsClear() {
  return {
    type: _constants.COMMENTS_CLEAR
  };
};
/**
 * Action to get comments feed
 * @param {Object} assetData - metadata for current asset
 * @param {boolean} isOffline - boolean to know if user is offline or online
 * @param {boolean} cacheComments - boolean to know if comments should be cached or not in local storage
 * @param {boolean} imsId - ims id of user fetching comments
 * @param {boolean} imageCapture - Boolean indicating if image capture feature is enabled
 * @param {boolean} globalComments - Boolean indicating if globalComments is enabled
 * @param {boolean} isGlobalCommentsToggleActive - Boolean indicating if globalComments toggle is on
 * @param {boolean} globalCommentsUnmapped - Boolean indicating if globalCommentsUnmapped is enabled
 * @returns {Promise} promise to resolve/reject once HTTP is completed
 */


exports.commentsClear = commentsClear;

var commentsGet = function commentsGet(assetData, isOffline, cacheComments, imsId, imageCapture, globalComments, isGlobalCommentsToggleActive, globalCommentsUnmapped // eslint-disable-next-line max-params
) {
  return function (dispatch) {
    var asset = new _commentsSdk.Asset(assetData.id);
    var showCachedData = false;
    getIngestController().fireEvent(_ingestEvents.default.commentLoad);

    if (cacheComments) {
      // check if comments are already in ls cache
      _LocalStorageManager.default.configure({
        namespace: imsId,
        shouldExpire: true,
        expirationDuration: 2592000 // value in seconds. 30 days = 2592000 seconds

      }); // when online, time limit to fetch api data is 10 minutes and so within 10 minutes, show cached data


      var TIME_LIMIT_TO_FETCH_DATA = 10; // value in minutes.

      var cachedComments = _LocalStorageManager.default.get(assetData.id);

      var timeDiffWithinLimit = cachedComments && Date.now() - cachedComments.createdTimeStamp <= 60000 * TIME_LIMIT_TO_FETCH_DATA;
      showCachedData = cachedComments && !isOffline && timeDiffWithinLimit || cachedComments && isOffline;

      if (showCachedData) {
        dispatch({
          data: cachedComments.data.comments,
          cacheComments: cacheComments,
          assetId: assetData.id,
          type: _constants.COMMENTS_GET.SUCCESS
        });

        if (isOffline) {
          var event = hasVisibleComments(cachedComments.data.comments, assetData, {
            globalComments: globalComments,
            isGlobalCommentsToggleActive: isGlobalCommentsToggleActive,
            globalCommentsUnmapped: globalCommentsUnmapped
          }) ? _ingestEvents.default.commentLoad : _ingestEvents.default.noComments;
          getIngestController().fireEvent(event);
          return Promise.resolve(asset);
        }
      }
    }

    if (!showCachedData) {
      dispatch({
        type: _constants.COMMENTS_GET.START
      });
    }

    return new Promise(function (resolve, reject) {
      asset.get().then(function (annotationsCollection) {
        var comments = annotationsCollection.annotations; // Handle image capture prep

        if (imageCapture && comments && comments.length) {
          // Perform the least expensive modification loop through the comments possible
          comments.forEach(function (annotation) {
            var imageContextData = (0, _utils.loadFromLocalStorage)(annotation.id);

            if (imageContextData) {
              annotation.imageContextData = imageContextData;
            }
          });
        }

        dispatch({
          data: comments,
          cacheComments: cacheComments,
          assetId: assetData.id,
          type: _constants.COMMENTS_GET.SUCCESS
        });
        var event = hasVisibleComments(comments, assetData, {
          globalComments: globalComments,
          isGlobalCommentsToggleActive: isGlobalCommentsToggleActive,
          globalCommentsUnmapped: globalCommentsUnmapped
        }) ? _ingestEvents.default.commentsRender : _ingestEvents.default.noComments;
        getIngestController().fireEvent(event);
        resolve(asset);
      }).catch(function (error) {
        dispatch({
          type: _constants.COMMENTS_GET.ERROR,
          error: 'list'
        });
        getIngestController().fireEvent(_ingestEvents.default.commentsFailedToLoad(error.status, error.message));
        reject(error);
      });
    });
  };
};

exports.commentsGet = commentsGet;

var commentsUpdate = function commentsUpdate(annotationsCollection, assetId, cacheComments) {
  return {
    type: _constants.COMMENTS_GET.SUCCESS,
    data: annotationsCollection.annotations,
    // used in delta middleware.
    isPollUpdate: true,
    cacheComments: cacheComments,
    assetId: assetId
  };
};
/**
 * Action to create one dirty comment per artboard with text and annotation location
 * @param {string} artboardID - artboard ID
 * @param {string} comment - comment text
 * @param {object} location - annotation location
 * @returns {undefined}
 */


exports.commentsUpdate = commentsUpdate;

var commentsAddDirtyComment = function commentsAddDirtyComment(artboardID, comment, location) {
  return {
    type: _constants.COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD,
    artboardID: artboardID,
    comment: comment,
    location: location
  };
};
/**
 * Action to clear all filters
 * @returns {undefined}
 */


exports.commentsAddDirtyComment = commentsAddDirtyComment;

var commentsFilterClear = function commentsFilterClear() {
  return {
    type: _constants.COMMENTS_FILTER_CLEAR
  };
};
/**
 * Action to set the time filters
 * @param {Array} values - times to filter by
 * @returns {undefined}
 */


exports.commentsFilterClear = commentsFilterClear;

var commentsFilterTime = function commentsFilterTime(values) {
  return {
    type: _constants.COMMENTS_FILTER_TIME,
    values: values
  };
};
/**
 * Action to set the user filters
 * @param {Array} values - a list of user id to filter by
 * @returns {undefined}
 */


exports.commentsFilterTime = commentsFilterTime;

var commentsFilterUsers = function commentsFilterUsers(values) {
  return {
    type: _constants.COMMENTS_FILTER_USERS,
    values: values
  };
};
/**
 * Action to toggle between open and closed state of replies.
 * @param {string} id - comment id
 * @param {string} draftReplyText - optional drafted reply text
 * @return {undefined}
 */


exports.commentsFilterUsers = commentsFilterUsers;

var commentsToggleReply = function commentsToggleReply(id, draftReplyText) {
  return {
    type: _constants.COMMENTS_TOGGLE_REPLY,
    id: id,
    draftReplyText: draftReplyText
  };
};
/**
 * Action to set showAnnotations state
 * @param {boolean} showAnnotations - whether the annotations are shown or not
 * @returns {undefined}
 */


exports.commentsToggleReply = commentsToggleReply;

var commentsSetShowAnnotations = function commentsSetShowAnnotations(showAnnotations) {
  (0, _utils.saveToLocalStorage)('showAnnotations', showAnnotations);
  return {
    type: _constants.COMMENTS_SET_SHOW_ANNOTATIONS,
    showAnnotations: showAnnotations
  };
};
/**
 * Action to toggle between resolved and open states
 * @returns {undefined}
 */


exports.commentsSetShowAnnotations = commentsSetShowAnnotations;

var toggleResolved = function toggleResolved() {
  return function (dispatch) {
    dispatch({
      type: _constants.COMMENTS_TOGGLE_RESOLVED
    });
  };
};
/**
 * Action to resolve a comment.
 * @param {string} assetId - ID of the current asset
 * @param {Object} comment - comment to be resolved
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @returns {Promise} promise to resolve/reject once comment is resolved
 */


exports.toggleResolved = toggleResolved;

var commentsResolve = function commentsResolve(assetId, comment, cacheComments) {
  return function (dispatch, getState) {
    var state = getState();
    var remappedMap = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.remappedMap"));
    var cleanedComment = cleanCommentDataForCommentsService(comment, remappedMap); // stupid hack for CCX-3032
    // Comments Service considers `mentions: [{id: 1, name: "John"}]` different than `mentions: [{name: "John", id: 1}]`
    // This means Comments Service will consider this an edit and you will run into a permission issue if you're not the owner
    // But deleting mentions before resolving or unresolving seems to work for now.

    delete cleanedComment.mentions;
    var annotation = new _commentsSdk.Annotation(assetId, cleanedComment);
    dispatch({
      comment: annotation,
      type: _constants.COMMENTS_RESOLVE.START
    });
    return annotation.resolve().then(function (newAnnotation) {
      dispatch({
        comment: newAnnotation,
        cacheComments: cacheComments,
        assetId: assetId,
        type: _constants.COMMENTS_RESOLVE.SUCCESS
      });
    }).catch(function (error) {
      dispatch({
        comment: annotation,
        error: comment.id,
        type: _constants.COMMENTS_RESOLVE.ERROR
      });
      throw error;
    });
  };
};
/**
 * Action to open a comment.
 * @param {string} assetId - ID of the current asset
 * @param {Object} comment - comment to be opened
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @returns {Promise} promise to resolve/reject once comment is opened
 */


exports.commentsResolve = commentsResolve;

var commentsOpen = function commentsOpen(assetId, comment, cacheComments) {
  return function (dispatch, getState) {
    var state = getState();
    var remappedMap = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.remappedMap"));
    var cleanedComment = cleanCommentDataForCommentsService(comment, remappedMap); // stupid hack for CCX-3032
    // Comments Service considers `mentions: [{id: 1, name: "John"}]` different than `mentions: [{name: "John", id: 1}]`
    // This means Comments Service will consider this an edit and you will run into a permission issue if you're not the owner
    // But deleting mentions before resolving or unresolving seems to work for now.

    delete cleanedComment.mentions;
    var annotation = new _commentsSdk.Annotation(assetId, cleanedComment);
    dispatch({
      comment: annotation,
      type: _constants.COMMENTS_OPEN.START
    });
    return annotation.open().then(function (newAnnotation) {
      dispatch({
        comment: newAnnotation,
        cacheComments: cacheComments,
        assetId: assetId,
        type: _constants.COMMENTS_OPEN.SUCCESS
      });
    }).catch(function (error) {
      dispatch({
        comment: annotation,
        error: comment.id,
        type: _constants.COMMENTS_OPEN.ERROR
      });
      throw error;
    });
  };
};
/**
 * Posts a reply.
 * @param {string} assetId - ID of the current asset
 * @param {string} replyText - reply text
 * @param {string} parentCommentId - id for parent comment
 * @param {Array} mentionedUsers - optional array of @mentioned user objects
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @return {Promise} promise to resolve/reject once HTTP is completed
 */


exports.commentsOpen = commentsOpen;

var postReply = function postReply(assetId, replyText, parentCommentId, mentionedUsers, cacheComments) {
  return function (dispatch, getState) {
    var commentsState = getState()["".concat(_constants.PREFIX, ":comments")];
    var parentComment = commentsState.comments.find(function (_ref3) {
      var id = _ref3.id;
      return id === parentCommentId;
    });
    var annotation = new _commentsSdk.Annotation(assetId, parentComment); // Clean the mentions data for submit

    var mentionData = cleanMentionDataForCommentsService(mentionedUsers, replyText);
    dispatch({
      parentCommentId: parentCommentId,
      type: _constants.POST_REPLY.START
    });
    return annotation.reply(replyText, mentionData).then(function (reply) {
      dispatch({
        reply: reply,
        parentCommentId: parentCommentId,
        assetId: assetId,
        cacheComments: cacheComments,
        type: _constants.POST_REPLY.SUCCESS
      }); // REPLY comment

      getIngestController().fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: 'reply-comment',
          subtype: 'reply',
          type: 'render'
        },
        content: {
          parent_id: reply.id
        }
      });

      if (reply.mentions.length) {
        getIngestController().fireEvent({
          event: {
            subcategory: 'reply-comment',
            subtype: 'mention',
            type: 'render'
          },
          content: {
            parent_id: reply.id
          }
        });
      } // Clear out 'justAdded'


      dispatch(commentsSetRecentActivity(parentCommentId, reply.id));
      return reply;
    }).catch(function (error) {
      dispatch({
        error: 'reply',
        type: _constants.POST_REPLY.ERROR
      });
      throw error;
    });
  };
};
/**
 * Action to post a comment or reply
 * @param {string} assetId - ID of the current asset
 * @param {string} nodeId - ID of the specific node inside of the current asset
 * @param {string} commentTxt - Text of the new comment
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @param {boolean} shouldUseAnnotationLocation - Boolean indicating if we should use stored annotation location data
 * @param {Array} mentionedUsers - optional array of @mentioned user objects
 * @param {boolean} imageCapture - Boolean indicating if image capture feature is enabled
 * @param {boolean} imageContextData - Data for image capture saving
 * @returns {Promise} promise to resolve/reject once HTTP is completed
 */


exports.postReply = postReply;

var commentsPost = function commentsPost(assetId, nodeId, commentTxt, cacheComments, shouldUseAnnotationLocation, mentionedUsers, imageCapture, imageContextData // eslint-disable-next-line max-params
) {
  return function (dispatch, getState) {
    dispatch({
      assetId: assetId,
      type: _constants.COMMENTS_POST.START
    });
    var state = getState();
    var context = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context")) || {};
    var annotationNodeId;
    var coordinates;

    if (shouldUseAnnotationLocation && context.annotationLocation) {
      annotationNodeId = context.annotationLocation.nodeId;
      coordinates = context.annotationLocation.coordinates;
    } // Clean the mentions data for submit


    var mentionData = cleanMentionDataForCommentsService(mentionedUsers, commentTxt);
    var asset = new _commentsSdk.Asset(assetId);
    return new Promise(function (resolve, reject) {
      asset.comment(commentTxt, annotationNodeId === undefined ? nodeId : annotationNodeId, coordinates, mentionData).then(function (newAnnotation) {
        var _newAnnotation$target, _newAnnotation$target2;

        // Store image data in local storage for image capture POC
        if (imageContextData !== null && imageContextData !== void 0 && imageContextData.base64Data) {
          (0, _utils.saveToLocalStorage)(newAnnotation.id, imageContextData);
          newAnnotation.imageContextData = imageContextData;
        }

        dispatch({
          comment: newAnnotation,
          assetId: assetId,
          cacheComments: cacheComments,
          type: _constants.COMMENTS_POST.SUCCESS
        }); // parent comment

        var subTypeTosubCategoryMap = {
          note: 'pin-comment',
          shape: 'draw-comment',
          highlight: 'highlight-comment',
          strikethrough: 'strikethrough-comment',
          insert: 'insert-comment',
          replace: 'replace-comment'
        };
        var subcategory = subTypeTosubCategoryMap[(_newAnnotation$target = newAnnotation.target) === null || _newAnnotation$target === void 0 ? void 0 : (_newAnnotation$target2 = _newAnnotation$target.selector) === null || _newAnnotation$target2 === void 0 ? void 0 : _newAnnotation$target2.subtype] || 'post-comment';
        getIngestController().fireEvent({
          event: {
            subcategory: subcategory,
            subtype: 'comment',
            type: 'render'
          },
          content: {
            parent_id: newAnnotation.id
          }
        });

        if (newAnnotation.mentions.length) {
          getIngestController().fireEvent({
            event: {
              subcategory: subcategory,
              subtype: 'mention',
              type: 'render'
            },
            content: {
              parent_id: newAnnotation.id
            }
          });
        } // Clear out 'justAdded'


        dispatch(commentsSetRecentActivity(newAnnotation.id));
        resolve(newAnnotation);
      }).catch(function (error) {
        dispatch({
          error: 'root',
          type: _constants.COMMENTS_POST.ERROR
        });
        reject(error);
      });
    });
  };
};
/**
 * Action to propose comment for delete
 * @param {string} commentId - ID of the comment to propose for delete
 * @param {string} parentCommentId - ID of the parent comment (used for replies)
 * @returns {undefined}
 */


exports.commentsPost = commentsPost;

var commentDeletePropose = function commentDeletePropose(commentId, parentCommentId) {
  return {
    id: commentId,
    parentCommentId: parentCommentId,
    type: _constants.COMMENTS_PROPOSE_FOR_DELETE
  };
};
/**
 * Action to cancel comment for delete
 * @returns {undefined}
 */


exports.commentDeletePropose = commentDeletePropose;

var commentCancelForDelete = function commentCancelForDelete() {
  return function (dispatch) {
    dispatch({
      type: _constants.COMMENTS_CANCEL_FOR_DELETE
    });
  };
};
/**
 * Action to confirm delete for a comment
 * @param {string} assetId - ID of the current asset
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @returns {undefined}
 */


exports.commentCancelForDelete = commentCancelForDelete;

var commentConfirmForDelete = function commentConfirmForDelete(assetId, cacheComments) {
  return function (dispatch, getState) {
    var state = getState();
    var comments = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments")) || {};
    var _comments$commentProp = comments.commentProposedForDelete,
        id = _comments$commentProp.id,
        parentCommentId = _comments$commentProp.parentCommentId;

    if (assetId && comments.commentProposedForDelete) {
      var annotation = new _commentsSdk.Annotation(assetId, comments.commentProposedForDelete); // Delete image data in local storage for image capture POC

      (0, _utils.deleteFromLocalStorage)(id);
      return new Promise(function (resolve, reject) {
        annotation.delete().then(function () {
          dispatch({
            id: id,
            parentCommentId: parentCommentId,
            cacheComments: cacheComments,
            assetId: assetId,
            type: _constants.COMMENTS_DELETE.SUCCESS
          });
          resolve();
        }).catch(function (error) {
          var errorKey = comments.commentProposedForDelete.id;
          dispatch({
            error: errorKey,
            type: _constants.COMMENTS_DELETE.ERROR
          });
          reject(error);
        });
      });
    }
  };
};
/**
 * Action to edit a comment or reply.
 * @param {string} assetId - ID of the current asset
 * @param {string} comment - Object of comment we are editing
 * @param {string} parentCommentId - Parent comment object's id if this is a reply
 * @param {string} commentTxt - Text of the edited comment
 * @param {Array} mentionedUsers - optional array of @mentioned user objects
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @param {boolean} imageCapture - Boolean indicating if image capture feature is enabled
 * @returns {Promise} promise to resolve/reject once HTTP is completed
 */


exports.commentConfirmForDelete = commentConfirmForDelete;

var commentsEdit = function commentsEdit(assetId, comment, parentCommentId, commentTxt) {
  var mentionedUsers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var cacheComments = arguments.length > 5 ? arguments[5] : undefined;
  var imageCapture // eslint-disable-next-line max-params
  = arguments.length > 6 ? arguments[6] : undefined;
  return function (dispatch, getState) {
    var state = getState();
    var context = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context"));
    var remappedMap = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.remappedMap"));
    var cleanedComment = cleanCommentDataForCommentsService(comment, remappedMap);
    var id = comment.id,
        draftReplyText = comment.draftReplyText,
        repliesOpen = comment.repliesOpen;
    var imageContextData = context.imageContextData;
    var annotation = new _commentsSdk.Annotation(assetId, cleanedComment); // Clean the mentions data for submit

    var mentionData = cleanMentionDataForCommentsService(mentionedUsers, commentTxt);
    dispatch({
      id: id,
      parentCommentId: parentCommentId,
      type: _constants.COMMENTS_EDIT.START
    });
    return annotation.update(commentTxt, null, mentionData, null).then(function (updatedCommentData) {
      updatedCommentData.draftReplyText = draftReplyText;
      updatedCommentData.repliesOpen = Boolean(draftReplyText || repliesOpen); // Store image data in local storage for image capture POC

      if (imageCapture && imageContextData.base64Data) {
        (0, _utils.saveToLocalStorage)(updatedCommentData.id, imageContextData);
        updatedCommentData.imageContextData = imageContextData;
      }

      dispatch({
        updatedCommentData: updatedCommentData,
        parentCommentId: parentCommentId,
        cacheComments: cacheComments,
        assetId: assetId,
        type: _constants.COMMENTS_EDIT.SUCCESS
      }); // Clear out justEdited

      if (parentCommentId) {
        dispatch(commentsSetRecentActivity(parentCommentId, updatedCommentData.id));
      } else {
        dispatch(commentsSetRecentActivity(updatedCommentData.id));
      }
    }).catch(function (error) {
      dispatch({
        error: id,
        type: _constants.COMMENTS_EDIT.ERROR
      });
      throw error;
    });
  };
};
/**
 * Action to edit a comment by updating annotation coordinates
 * associated with the comment.
 * @param {string} assetId - ID of the current asset
 * @param {string} comment - Object of comment we are editing
 * @param {Object} coordinates - coordinates for the new annotation
 * @param {Object} nodeId - node ID for the annotation if it is something other than current node ID
 * @return {Promise} promise to resolve/reject once HTTP is completed
 */


exports.commentsEdit = commentsEdit;

var updateAnnotation = function updateAnnotation(assetId, comment, coordinates, nodeId) {
  return function (dispatch, getState) {
    var state = getState();
    var remappedMap = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.remappedMap"));
    var id = comment.id,
        bodyValue = comment.bodyValue,
        draftReplyText = comment.draftReplyText,
        mentions = comment.mentions,
        repliesOpen = comment.repliesOpen,
        dirtyEdit = comment.dirtyEdit;
    var cleanedComment = cleanCommentDataForCommentsService(comment, remappedMap);
    var annotation = new _commentsSdk.Annotation(assetId, cleanedComment);
    dispatch((0, _context.setAnnotatingCommentId)(id));
    dispatch((0, _context.contextSaveAnnotationLocation)(coordinates, nodeId));
    return annotation.update(bodyValue, coordinates, mentions, nodeId).then(function (updatedComment) {
      updatedComment.draftReplyText = draftReplyText;
      updatedComment.repliesOpen = !!draftReplyText || repliesOpen;
      updatedComment.dirtyEdit = dirtyEdit;
      dispatch({
        assetId: assetId,
        updatedComment: updatedComment,
        type: _constants.UPDATE_ANNOTATION.SUCCESS
      }); // Clear out justEdited

      dispatch(commentsSetRecentActivity(updatedComment.id));
    }).catch(function (error) {
      dispatch({
        error: id,
        type: _constants.UPDATE_ANNOTATION.ERROR
      });
      throw error;
    });
  };
};
/**
 * Action to remap a comment to a new node
 * @param {object} mappingData - object containing comment ID to node ID map for remapping
 * @returns {object} action for remapCommentNodes action creator
 */


exports.updateAnnotation = updateAnnotation;

var remapCommentNodes = function remapCommentNodes(mappingData) {
  return {
    type: _constants.COMMENTS_REMAP_COMMENT_NODES,
    mappingData: mappingData
  };
};
/**
 * Action to handle batch updates
 * @param {string} assetId - ID of the current asset
 * @param {object} mappingData - object containing comment ID to new target object
 * @param {boolean} cacheComments - boolean to decide if comments should be cached or not
 * @param {boolean} updateRedux - indication if update should be propigated to Redux
 * @returns {Promise} promise to resolve/reject once HTTP is completed
 */


exports.remapCommentNodes = remapCommentNodes;

var batchCommentUpdate = function batchCommentUpdate(assetId, mappingData, cacheComments, updateRedux) {
  return function (dispatch) {
    var asset = new _commentsSdk.Asset(assetId);
    return new Promise(function (resolve, reject) {
      asset.remap(mappingData).then(function (remappedData) {
        var commentsToUpdate = [];
        var updatedIds = [];
        Object.keys(remappedData).forEach(function (remappedId) {
          if (_typeof(remappedData[remappedId]) === _typeof(new _commentsSdk.Annotation())) {
            commentsToUpdate.push(remappedData[remappedId]);
            updatedIds.push(remappedId);
          }
        });

        if (updateRedux) {
          dispatch({
            assetId: assetId,
            cacheComments: cacheComments,
            commentsToUpdate: commentsToUpdate,
            type: _constants.COMMENTS_BATCH_REMAP.SUCCESS
          });
        }

        resolve(updatedIds);
      }).catch(function (error) {
        reject(error);
      });
    });
  };
};

exports.batchCommentUpdate = batchCommentUpdate;